const SvgSoftware5 = (props) => (
  <>
    <path
      d="M36 4h24v24H36zM68 68h24v24H68zM36 68h24v24H36zM68 36h24v24H68zM4 36h24v24H4zM4 4h24v24H4zM36 36h24v24H36zM4 68h24v24H4zM68 4h24v24H68z"
      fill={props.p40}
    />
  </>
);

export default SvgSoftware5;
